<template>
    <div class="z-filelist" :class="buildClass">
        <slot/>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    horizontal: {
        type: Boolean
    },
    border: {
        type: Boolean
    }
})

const buildClass = computed(() => {
    return [
        {
            'z-filelist--horizontal': props.horizontal,
            'z-filelist--vertical': !props.horizontal,
            'z-filelist--border': props.border
        }
    ]
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
